/* ============================================================
   NAEEM — Main JavaScript
   ============================================================ */

'use strict';

/* ——— LED Dot-Matrix Renderer ——— */
const NaeemLED = {
  SEGMENTS: {
    0: [1,1,1,1,1,1,0],
    1: [0,1,1,0,0,0,0],
    2: [1,1,0,1,1,0,1],
    3: [1,1,1,1,0,0,1],
    4: [0,1,1,0,0,1,1],
    5: [1,0,1,1,0,1,1],
    6: [1,0,1,1,1,1,1],
    7: [1,1,1,0,0,0,0],
    8: [1,1,1,1,1,1,1],
    9: [1,1,1,1,0,1,1],
  },

  /* Draw a single 7-segment digit using dots */
  drawDigit(ctx, digit, x, y, dotSize, gap, color) {
    const d = this.SEGMENTS[digit] || [0,0,0,0,0,0,0];
    const cols = 4;
    const rows = 7;
    const step = dotSize + gap;

    /* Map: segment index → grid rows to activate */
    const segMap = [
      /* top h */        { r: 0, cStart: 1, cEnd: 3, horiz: true  },
      /* top-right v */  { r: 1, cStart: 3, rEnd: 3, horiz: false },
      /* bot-right v */  { r: 4, cStart: 3, rEnd: 6, horiz: false },
      /* bottom h */     { r: 6, cStart: 1, cEnd: 3, horiz: true  },
      /* bot-left v */   { r: 4, cStart: 0, rEnd: 6, horiz: false },
      /* top-left v */   { r: 1, cStart: 0, rEnd: 3, horiz: false },
      /* middle h */     { r: 3, cStart: 1, cEnd: 3, horiz: true  },
    ];

    /* Draw a full grid of dim dots first */
    const dimColor = 'rgba(74,158,255,0.08)';
    for (let row = 0; row < rows; row++) {
      for (let col = 0; col < cols; col++) {
        ctx.fillStyle = dimColor;
        ctx.fillRect(x + col * step, y + row * step, dotSize, dotSize);
      }
    }

    /* Now draw active dots per segment */
    segMap.forEach((seg, i) => {
      if (!d[i]) return;
      ctx.fillStyle = color;
      if (seg.horiz) {
        for (let c = seg.cStart; c <= seg.cEnd; c++) {
          const row = seg.r;
          ctx.fillStyle = color;
          ctx.shadowColor = color;
          ctx.shadowBlur = dotSize * 1.8;
          ctx.fillRect(x + c * step, y + row * step, dotSize, dotSize);
          ctx.shadowBlur = 0;
        }
      } else {
        for (let r = seg.r; r <= seg.rEnd; r++) {
          const col = seg.cStart;
          ctx.fillStyle = color;
          ctx.shadowColor = color;
          ctx.shadowBlur = dotSize * 1.8;
          ctx.fillRect(x + col * step, y + r * step, dotSize, dotSize);
          ctx.shadowBlur = 0;
        }
      }
    });
  },

  render(canvas, number) {
    if (!canvas || !canvas.getContext) return;
    const ctx = canvas.getContext('2d');
    const w = canvas.width;
    const h = canvas.height;

    ctx.clearRect(0, 0, w, h);

    const str = String(Math.max(0, Math.min(9999, number))).padStart(2, '0');
    const digits = str.split('').map(Number);

    const dotSize = Math.round(h / 11);
    const gap = Math.round(dotSize * 0.5);
    const digitW = 4 * dotSize + 3 * gap;
    const digitH = 7 * dotSize + 6 * gap;
    const totalW = digits.length * digitW + (digits.length - 1) * (gap * 3);
    const startX = (w - totalW) / 2;
    const startY = (h - digitH) / 2;
    const color = '#4A9EFF';

    digits.forEach((d, i) => {
      const x = startX + i * (digitW + gap * 3);
      this.drawDigit(ctx, d, x, startY, dotSize, gap, color);
    });
  }
};

/* ——— Header Scroll Effect ——— */
function initHeader() {
  const header = document.getElementById('naeem-header');
  if (!header) return;

  let last = 0;
  const handler = () => {
    const y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 60);
    last = y;
  };
  window.addEventListener('scroll', handler, { passive: true });
  handler();
}

/* ——— Hero Image Load ——— */
function initHeroImage() {
  const img = document.querySelector('.naeem-hero__bg-img');
  if (!img) return;
  if (img.complete) {
    img.classList.add('is-loaded');
  } else {
    img.addEventListener('load', () => img.classList.add('is-loaded'));
  }
}

/* ——— Mobile Nav ——— */
function initMobileNav() {
  const toggle  = document.getElementById('naeem-mobile-toggle');
  const close   = document.getElementById('naeem-mobile-close');
  const overlay = document.getElementById('naeem-mobile-overlay');
  const nav     = document.getElementById('naeem-mobile-nav');
  if (!toggle || !nav) return;

  const open  = () => { nav.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; toggle.setAttribute('aria-expanded', 'true'); };
  const shut  = () => { nav.setAttribute('aria-hidden', 'true');  document.body.style.overflow = '';       toggle.setAttribute('aria-expanded', 'false'); };

  toggle.addEventListener('click', open);
  if (close)   close.addEventListener('click', shut);
  if (overlay) overlay.addEventListener('click', shut);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') shut(); });
}

/* ——— Scroll lock (iOS-safe) ——— */
let _drawerScrollY = 0;
function openCartDrawer() {
  const drawer = document.getElementById('naeem-cart-drawer');
  if (!drawer) return;
  _drawerScrollY = window.scrollY;
  drawer.setAttribute('aria-hidden', 'false');
  document.body.style.position  = 'fixed';
  document.body.style.top       = `-${_drawerScrollY}px`;
  document.body.style.width     = '100%';
}
function closeCartDrawer() {
  const drawer = document.getElementById('naeem-cart-drawer');
  if (!drawer) return;
  drawer.setAttribute('aria-hidden', 'true');
  document.body.style.position  = '';
  document.body.style.top       = '';
  document.body.style.width     = '';
  window.scrollTo(0, _drawerScrollY);
}

/* ——— Cart Drawer ——— */
function initCartDrawer() {
  const drawer  = document.getElementById('naeem-cart-drawer');
  const openBtn = document.getElementById('naeem-cart-toggle');
  const closeBtn= document.getElementById('naeem-cart-close');
  const overlay = drawer?.querySelector('.naeem-cart-drawer__overlay');
  if (!drawer || !openBtn) return;

  const open  = () => openCartDrawer();
  const shut  = () => closeCartDrawer();

  openBtn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', shut);
  if (overlay)  overlay.addEventListener('click', shut);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') shut(); });

  /* Cart quantity / remove via AJAX */
  drawer.addEventListener('click', async (e) => {
    const qtyBtn    = e.target.closest('[data-qty-change]');
    const removeBtn = e.target.closest('[data-remove-item]');

    if (qtyBtn) {
      const item  = qtyBtn.closest('[data-cart-item]');
      const line  = parseInt(item?.dataset?.line, 10);
      const delta = parseInt(qtyBtn.dataset.qtyChange, 10);
      const valEl = item?.querySelector('.naeem-cart-item__qty-val');
      if (!line || !valEl) return;
      const newQty = Math.max(0, parseInt(valEl.textContent, 10) + delta);
      await updateCartLine(line, newQty);
    }

    if (removeBtn) {
      const item = removeBtn.closest('[data-cart-item]');
      const line = parseInt(item?.dataset?.line, 10);
      if (!line) return;
      await updateCartLine(line, 0);
    }
  });
}

async function updateCartLine(line, qty) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity: qty })
    });
    const cart = await res.json();
    updateCartUI(cart);
  } catch (e) {
    console.error('Cart update failed', e);
  }
}

function updateCartUI(cart) {
  /* Header count badge */
  const headerCount = document.querySelector('.naeem-header__cart-count');
  if (headerCount) {
    headerCount.textContent = cart.item_count;
    headerCount.hidden = cart.item_count === 0;
  }
  const drawerCount = document.getElementById('cart-drawer-count');
  if (drawerCount) drawerCount.textContent = `(${cart.item_count})`;

  let itemsList = document.getElementById('naeem-cart-items');
  const emptyMsg  = document.getElementById('naeem-cart-empty');
  const footer    = document.getElementById('naeem-cart-footer');

  if (cart.item_count === 0) {
    if (itemsList) itemsList.innerHTML = '';
    if (emptyMsg)  emptyMsg.hidden = false;
    if (footer)    footer.innerHTML = '';
  } else {
    if (emptyMsg) emptyMsg.hidden = true;

    /* When cart was empty on page load the <ul> was never rendered —
       create it now and prepend it to the drawer body. */
    if (!itemsList) {
      const body = document.getElementById('naeem-cart-body');
      if (body) {
        itemsList = document.createElement('ul');
        itemsList.className = 'naeem-cart-drawer__items';
        itemsList.id = 'naeem-cart-items';
        body.prepend(itemsList);
      }
    }

    /* Rebuild item rows from AJAX data */
    if (itemsList) {
      itemsList.innerHTML = cart.items.map((item, i) => {
        const imgHtml = item.image
          ? `<img class="naeem-cart-item__image" src="${escapeHTML(item.image)}" alt="${escapeHTML(item.title)}" loading="lazy" width="100" height="100">`
          : '';
        const variantHtml = item.variant_title && item.variant_title !== 'Default Title'
          ? `<p class="naeem-cart-item__variant">${escapeHTML(item.variant_title)}</p>`
          : '';
        return `<li class="naeem-cart-item" data-cart-item data-line="${i + 1}">
            <div class="naeem-cart-item__image-wrap">${imgHtml}</div>
            <div class="naeem-cart-item__info">
              <p class="naeem-cart-item__title">${escapeHTML(item.product_title)}</p>
              ${variantHtml}
              <div class="naeem-cart-item__bottom">
                <div class="naeem-cart-item__qty">
                  <button class="naeem-cart-item__qty-btn" data-qty-change="-1" aria-label="Decrease quantity">–</button>
                  <span class="naeem-cart-item__qty-val">${item.quantity}</span>
                  <button class="naeem-cart-item__qty-btn" data-qty-change="1" aria-label="Increase quantity">+</button>
                </div>
                <span class="naeem-cart-item__price">${formatMoney(item.final_line_price)}</span>
              </div>
            </div>
            <button class="naeem-cart-item__remove" data-remove-item aria-label="Remove ${escapeHTML(item.title)}">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="1" stroke-linecap="round"/></svg>
            </button>
          </li>`;
      }).join('');
    }

    /* Rebuild footer with live subtotal and checkout link */
    if (footer) {
      footer.innerHTML = `<div class="naeem-cart-drawer__subtotal">
          <span>SUBTOTAL</span>
          <span id="cart-drawer-subtotal">${formatMoney(cart.total_price)}</span>
        </div>
        <p class="naeem-cart-drawer__note">Shipping calculated at checkout.</p>
        <a href="/checkout" class="naeem-btn naeem-btn--primary naeem-btn--lg naeem-cart-drawer__checkout">
          <span class="naeem-btn__label">CHECKOUT</span>
        </a>`;
    }
  }
}

function escapeHTML(str) {
  return String(str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function formatMoney(cents) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
}

/* ——— Add to Cart ——— */
async function initAddToCart() {
  const form = document.getElementById('naeem-atc-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('[data-atc-btn]');
    if (!btn || btn.disabled) return;

    const labelEl = btn.querySelector('.naeem-btn__label');
    const originalLabel = labelEl ? labelEl.textContent : 'ADD TO CART';

    btn.disabled = true;
    if (labelEl) labelEl.textContent = 'ADDING...';

    const formData = new FormData(form);
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(formData.get('id'), 10),
          quantity: parseInt(formData.get('quantity') || 1, 10)
        })
      });

      if (res.ok) {
        if (labelEl) labelEl.textContent = 'ADDED';
        /* Fetch updated cart, rebuild drawer, then open it */
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        updateCartUI(cart);
        openCartDrawer();
        setTimeout(() => {
          if (labelEl) labelEl.textContent = originalLabel;
          btn.disabled = false;
        }, 2000);
      } else {
        const errData = await res.json().catch(() => ({}));
        if (labelEl) labelEl.textContent = errData.description || 'TRY AGAIN';
        btn.disabled = false;
        setTimeout(() => {
          if (labelEl) labelEl.textContent = originalLabel;
        }, 3000);
      }
    } catch (err) {
      if (labelEl) labelEl.textContent = originalLabel;
      btn.disabled = false;
      console.error('Add to cart error:', err);
    }
  });
}

/* ——— Featured Product Gallery (collection section) ——— */
function initFeaturedGallery() {
  const mainImg = document.getElementById('naeem-featured-main-img');
  const thumbs  = document.querySelectorAll('.naeem-featured__thumb');
  if (!mainImg || !thumbs.length) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const src = thumb.dataset.fullSrc;
      if (!src) return;
      mainImg.style.transition = 'opacity 0.2s ease';
      mainImg.style.opacity = '0';
      setTimeout(() => {
        mainImg.src = src;
        mainImg.style.opacity = '1';
      }, 200);
    });
  });
}

/* ——— Product Gallery ——— */
function initProductGallery() {
  const main   = document.querySelector('.naeem-product-gallery__main-img');
  const thumbs = document.querySelectorAll('.naeem-product-gallery__thumb');
  if (!main || !thumbs.length) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const src = thumb.dataset.fullSrc;
      if (src) {
        main.style.opacity = '0';
        setTimeout(() => { main.src = src; main.style.opacity = '1'; }, 200);
      }
    });
  });
}

/* ——— Product Variants ——— */
function initVariants() {
  const options = document.querySelectorAll('.naeem-product-variants__option');
  const idInput = document.getElementById('naeem-variant-id');
  if (!options.length || !idInput) return;

  options.forEach(opt => {
    opt.addEventListener('click', () => {
      const group = opt.closest('.naeem-product-variants__options');
      group?.querySelectorAll('.naeem-product-variants__option').forEach(o => {
        o.classList.remove('is-active');
        o.setAttribute('aria-checked', 'false');
      });
      opt.classList.add('is-active');
      opt.setAttribute('aria-checked', 'true');
      const varId = opt.dataset.variantId;
      if (varId && idInput) idInput.value = varId;

      /* Update price */
      const price       = opt.dataset.price;
      const comparePrice = parseInt(opt.dataset.comparePrice || '0', 10);
      const priceCents  = parseInt(price, 10);
      const priceEl     = document.querySelector('.naeem-product-info__price');
      const compareEl   = document.getElementById('naeem-product-compare');
      const discountEl  = document.getElementById('naeem-product-discount');

      if (price && priceEl) priceEl.textContent = formatMoney(priceCents);

      if (compareEl) {
        if (comparePrice > priceCents) {
          compareEl.textContent = formatMoney(comparePrice);
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }
      if (discountEl) {
        if (comparePrice > priceCents) {
          const disc = Math.round((comparePrice - priceCents) * 100 / comparePrice);
          discountEl.textContent = `–${disc}%`;
          discountEl.hidden = false;
        } else {
          discountEl.textContent = '';
          discountEl.hidden = true;
        }
      }

      /* Update selected label */
      const selectedLabel = opt.closest('.naeem-product-variants')?.querySelector('.naeem-product-variants__selected');
      if (selectedLabel) selectedLabel.textContent = opt.textContent.trim();
    });
  });
}

/* ——— Product Quantity ——— */
function initProductQty() {
  const qtyEl  = document.querySelector('.naeem-product-qty__val');
  const decBtn = document.querySelector('[data-qty-dec]');
  const incBtn = document.querySelector('[data-qty-inc]');
  const input  = document.getElementById('naeem-qty-input');
  if (!qtyEl) return;

  let qty = 1;
  const set = (v) => {
    qty = Math.max(1, v);
    qtyEl.textContent = qty;
    if (input) input.value = qty;
  };

  decBtn?.addEventListener('click', () => set(qty - 1));
  incBtn?.addEventListener('click', () => set(qty + 1));
}

/* ——— Accordions ——— */
function initAccordions() {
  document.querySelectorAll('.naeem-accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const accordion = trigger.closest('.naeem-accordion, .naeem-faq__item');
      const isOpen = accordion.classList.contains('is-open');
      const group = accordion.closest('[data-accordion-group]');

      if (group) {
        group.querySelectorAll('.naeem-accordion, .naeem-faq__item').forEach(a => {
          a.classList.remove('is-open');
          a.querySelector('.naeem-accordion__trigger, .naeem-faq__question')?.setAttribute('aria-expanded', 'false');
        });
      }

      if (!isOpen) {
        accordion.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* FAQ questions */
  document.querySelectorAll('.naeem-faq__question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.naeem-faq__item');
      const isOpen = item.classList.contains('is-open');
      item.closest('.naeem-faq__category')?.querySelectorAll('.naeem-faq__item').forEach(i => i.classList.remove('is-open'));
      if (!isOpen) item.classList.add('is-open');
    });
  });
}

/* ——— Dhikr Interactive Counter ——— */
function initDhikr() {
  const tapBtn   = document.getElementById('naeem-tap-btn');
  const popup    = document.getElementById('naeem-dhikr-popup');
  const popAr    = document.getElementById('naeem-popup-arabic');
  const popTrans = document.getElementById('naeem-popup-transliteration');
  const popCount = document.getElementById('naeem-popup-count');
  const canvas   = document.getElementById('naeem-dhikr-canvas');
  const selectors= document.querySelectorAll('.naeem-dhikr__selector');

  if (!tapBtn) return;

  let state = {
    active: 'subhanallah',
    arabic: 'سبحان الله',
    transliteration: 'SubhanAllah',
    counts: {
      subhanallah:    18,
      alhamdulillah:  50,
      allahuakbar:    22,
      lailaha:         8,
      astaghfirullah: 47
    }
  };

  let popupTimer = null;

  function renderLED() {
    if (canvas) NaeemLED.render(canvas, state.counts[state.active]);
  }

  function showPopup() {
    if (!popup) return;
    clearTimeout(popupTimer);
    if (popAr)    popAr.textContent    = state.arabic;
    if (popTrans) popTrans.textContent = state.transliteration;
    if (popCount) popCount.textContent = state.counts[state.active];

    popup.classList.remove('is-hiding');
    popup.classList.add('is-visible');

    popupTimer = setTimeout(() => {
      popup.classList.remove('is-visible');
      popup.classList.add('is-hiding');
      setTimeout(() => popup.classList.remove('is-hiding'), 500);
    }, 1800);
  }

  function updateSelectorCounts() {
    selectors.forEach(sel => {
      const key   = sel.dataset.dhikr;
      const countEl = sel.querySelector('.naeem-dhikr__selector-count');
      if (countEl && key) countEl.textContent = state.counts[key];
    });
  }

  tapBtn.addEventListener('click', () => {
    state.counts[state.active]++;
    renderLED();
    showPopup();
    updateSelectorCounts();

    /* Subtle press animation */
    tapBtn.style.transform = tapBtn.id === 'naeem-tap-btn' && document.querySelector('.naeem-dhikr__ring-img-wrap')
      ? 'translate(-50%, 50%) scale(0.88)'
      : 'translateX(-50%) scale(0.88)';
    setTimeout(() => {
      tapBtn.style.transform = '';
    }, 120);
  });

  selectors.forEach(sel => {
    sel.addEventListener('click', () => {
      selectors.forEach(s => {
        s.classList.remove('is-active');
        s.setAttribute('aria-pressed', 'false');
      });
      sel.classList.add('is-active');
      sel.setAttribute('aria-pressed', 'true');
      state.active          = sel.dataset.dhikr;
      state.arabic          = sel.dataset.arabic;
      state.transliteration = sel.dataset.transliteration;
      renderLED();
    });
  });

  /* Initial render */
  renderLED();

  /* Hero LED */
  const heroCanvas = document.getElementById('hero-led-canvas');
  if (heroCanvas) NaeemLED.render(heroCanvas, 18);
}

/* ——— Hero LED init ——— */
function initHeroLED() {
  const canvas = document.getElementById('hero-led-canvas');
  if (canvas) NaeemLED.render(canvas, 18);
}

/* ——— Scroll reveal (minimal, performance safe) ——— */
function initScrollReveal() {
  if (!('IntersectionObserver' in window)) return;
  const els = document.querySelectorAll('[data-reveal]');
  if (!els.length) return;

  const obs = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

  els.forEach(el => obs.observe(el));
}

/* ——— Architecture layer parallax (scroll-driven) ——— */
function initArchLayers() {
  const layers = document.querySelectorAll('[data-arch-layer]');
  if (!layers.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const section = document.getElementById('naeem-architecture');
  if (!section) return;

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const rect   = section.getBoundingClientRect();
      const vH     = window.innerHeight;
      const prog   = Math.max(0, Math.min(1, 1 - (rect.top / vH)));
      const spread = prog > 0.5 ? (1 - prog) * 2 : prog * 2;

      layers.forEach(layer => {
        const idx = parseInt(layer.dataset.archLayer, 10);
        const dir = idx <= 2 ? -1 : 1;
        const amt = (idx - 2.5) * spread * 30;
        layer.style.transform = `translateY(${amt}px)`;
      });
      ticking = false;
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
}

/* ——— Lazy load images ——— */
function initLazyImages() {
  if (!('IntersectionObserver' in window)) return;
  const imgs = document.querySelectorAll('img[loading="lazy"]');
  /* Native lazy loading handles it — this is just for any edge cases */
}

/* ——— Multi-Product Showcase ——— */
function initShowcase() {
  const section = document.getElementById('naeem-collection');
  if (!section) return;

  const dataEl = document.getElementById('naeem-showcase-data');
  if (!dataEl) return;

  let products;
  try { products = JSON.parse(dataEl.textContent); }
  catch(e) { return; }
  if (!products || !products.length) return;

  const stage      = document.getElementById('naeem-sc-stage');
  const mainImg    = document.getElementById('naeem-sc-main-img');
  const thumbsWrap = document.getElementById('naeem-sc-thumbs');
  const badgeEl    = document.getElementById('naeem-sc-badge');
  const titleEl    = document.getElementById('naeem-sc-title');
  const descEl     = document.getElementById('naeem-sc-desc');
  const bensEl     = document.getElementById('naeem-sc-benefits');
  const priceEl    = document.getElementById('naeem-sc-price');
  const compareEl  = document.getElementById('naeem-sc-compare');
  const discountEl = document.getElementById('naeem-sc-discount');
  const variantIn  = document.getElementById('naeem-variant-id');
  const detailLink = document.getElementById('naeem-sc-detail');
  const tabs       = section.querySelectorAll('[data-sc-tab]');

  let activeIdx = 0;

  /* ——— Slideshow state ——— */
  const SLIDE_INTERVAL = 2000;
  const reducedMotion  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let slideshowTimer   = null;
  let currentImgIdx    = 0;

  function getActiveImages() {
    return (products[activeIdx] && products[activeIdx].images) || [];
  }

  function stopTimer() {
    if (slideshowTimer) { clearInterval(slideshowTimer); slideshowTimer = null; }
  }

  function startTimer() {
    if (reducedMotion) return;
    if (getActiveImages().length <= 1) return;
    stopTimer();
    slideshowTimer = setInterval(() => goToImageIdx(currentImgIdx + 1), SLIDE_INTERVAL);
  }

  function resetTimer() { stopTimer(); startTimer(); }

  function goToImageIdx(idx) {
    const images = getActiveImages();
    if (!images.length || !thumbsWrap) return;
    currentImgIdx = ((idx % images.length) + images.length) % images.length;
    const thumbBtns = thumbsWrap.querySelectorAll('.naeem-sc__thumb');
    const btn = thumbBtns[currentImgIdx];
    if (btn) switchThumb(btn, images[currentImgIdx].src);
  }
  /* ——— End slideshow state ——— */

  function switchThumb(btn, src) {
    if (!thumbsWrap) return;
    thumbsWrap.querySelectorAll('.naeem-sc__thumb').forEach(t => t.classList.remove('is-active'));
    btn.classList.add('is-active');
    if (mainImg && mainImg.tagName === 'IMG') {
      mainImg.style.opacity = '0';
      setTimeout(() => {
        mainImg.src = src;
        /* Double rAF guarantees the src change is committed to a new
           render frame before the fade-in transition starts — more
           reliable than getBoundingClientRect() on mobile browsers. */
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            mainImg.style.opacity = '1';
          });
        });
      }, 250);
    }
  }

  function bindThumbs() {
    if (!thumbsWrap) return;
    thumbsWrap.querySelectorAll('.naeem-sc__thumb').forEach((btn, i) => {
      btn.addEventListener('click', () => {
        currentImgIdx = i;
        const src = btn.dataset.fullSrc;
        if (src) switchThumb(btn, src);
        resetTimer();
      });
    });
  }

  function applyProduct(p) {
    stopTimer();
    currentImgIdx = 0;

    /* Main image */
    if (mainImg && mainImg.tagName === 'IMG' && p.images && p.images.length) {
      mainImg.src = p.images[0].src;
      mainImg.alt = p.images[0].alt || '';
    }

    /* Rebuild thumbnails */
    if (thumbsWrap) {
      const hasMulti = p.images && p.images.length > 1;
      thumbsWrap.style.display = hasMulti ? '' : 'none';
      thumbsWrap.innerHTML = '';
      if (hasMulti) {
        p.images.forEach((img, i) => {
          const btn = document.createElement('button');
          btn.className = 'naeem-sc__thumb' + (i === 0 ? ' is-active' : '');
          btn.type = 'button';
          btn.dataset.fullSrc = img.src;
          btn.setAttribute('aria-label', 'View image ' + (i + 1));
          const imgEl = document.createElement('img');
          imgEl.className = 'naeem-sc__thumb-img';
          imgEl.src = img.thumb;
          imgEl.alt = img.alt || '';
          imgEl.loading = 'lazy';
          btn.appendChild(imgEl);
          btn.addEventListener('click', () => {
            currentImgIdx = i;
            switchThumb(btn, img.src);
            resetTimer();
          });
          thumbsWrap.appendChild(btn);
        });
      }
    }

    /* Badge */
    if (badgeEl) {
      if (p.badge) {
        badgeEl.style.display = '';
        badgeEl.innerHTML = '<svg class="naeem-sc__badge-icon" width="10" height="10" viewBox="0 0 10 10" fill="currentColor" aria-hidden="true"><path d="M5 0l1.12 2.28 2.51.37-1.82 1.77.43 2.51L5 5.77 2.76 6.93l.43-2.51L1.37 2.65l2.51-.37L5 0z"/></svg>' + p.badge.toUpperCase();
      } else {
        badgeEl.style.display = 'none';
      }
    }

    /* Text */
    if (titleEl) titleEl.textContent = p.title || '';
    if (descEl)  descEl.textContent  = p.description || '';

    /* Benefits */
    if (bensEl) {
      const bens = [p.benefit_1, p.benefit_2, p.benefit_3, p.benefit_4].filter(Boolean);
      bensEl.innerHTML = bens.map(b => '<li><span class="naeem-sc__check" aria-hidden="true"></span>' + b + '</li>').join('');
    }

    /* Price */
    if (priceEl) priceEl.textContent = p.price || '';
    if (compareEl) { compareEl.textContent = p.compare_price || ''; compareEl.hidden = !p.compare_price; }
    if (discountEl) { discountEl.textContent = p.discount > 0 ? ('–' + p.discount + '%') : ''; discountEl.hidden = !p.discount; }

    /* ATC */
    if (variantIn) variantIn.value = p.variant_id || '';
    const atcBtn = document.querySelector('#naeem-atc-form [data-atc-btn]');
    if (atcBtn) {
      atcBtn.disabled = !p.available;
      const lbl = atcBtn.querySelector('.naeem-btn__label');
      if (lbl) lbl.textContent = p.available ? 'SHOP THE RING' : 'SOLD OUT';
    }

    /* Detail link */
    if (detailLink) detailLink.href = p.url || '#';

    startTimer();
  }

  function switchProduct(idx) {
    if (idx === activeIdx) return;
    activeIdx = idx;
    const p = products[idx];
    if (!p) return;

    if (stage) {
      stage.classList.add('is-switching');
      setTimeout(() => {
        applyProduct(p);
        stage.classList.remove('is-switching');
      }, 200);
    } else {
      applyProduct(p);
    }
  }

  /* Sliding selector pill */
  var selectorPill = section.querySelector('.naeem-sc__selector-pill');
  function positionPill() {
    var activeTab = section.querySelector('[data-sc-tab].is-active');
    if (!selectorPill || !activeTab) return;
    selectorPill.style.left  = activeTab.offsetLeft + 'px';
    selectorPill.style.width = activeTab.offsetWidth + 'px';
  }

  /* Wire tabs */
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const idx = parseInt(tab.dataset.scTab, 10);
      tabs.forEach(t => { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      positionPill();
      switchProduct(idx);
    });
  });

  /* Wire initial SSR thumbnails */
  bindThumbs();

  /* Pause on hover / focus over the gallery column */
  const imgCol = section.querySelector('.naeem-sc__img-col');
  if (imgCol) {
    imgCol.addEventListener('mouseenter', stopTimer);
    imgCol.addEventListener('mouseleave', startTimer);
    imgCol.addEventListener('focusin',    stopTimer);
    imgCol.addEventListener('focusout',   startTimer);
  }

  /* Place pill on load (no transition yet), then enable transition */
  positionPill();
  setTimeout(function() {
    if (selectorPill) {
      selectorPill.style.transition = 'left 0.3s var(--ease-out-quart), width 0.3s var(--ease-out-quart)';
    }
  }, 50);
  window.addEventListener('resize', positionPill);

  /* Kick off slideshow */
  startTimer();
}

/* ——— Boot ——— */
function boot() {
  initHeader();
  initHeroImage();
  initMobileNav();
  initCartDrawer();
  initAddToCart();
  initShowcase();
  initFeaturedGallery();
  initProductGallery();
  initVariants();
  initProductQty();
  initAccordions();
  initDhikr();
  initHeroLED();
  initScrollReveal();
  initArchLayers();
  initLazyImages();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
